export default{sources:{avif:"__VITE_ASSET__DKYQduDU__ 400w",webp:"__VITE_ASSET__BG42KDnD__ 400w"},img:{src:"__VITE_ASSET__cwjJ2g72__",w:400,h:300}};